// sm	640px
// md	768px
// lg	1024px
// xl	1280px
// 2xl	1536px

import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { fromEvent, startWith, switchMap, tap } from 'rxjs';

interface ResponsiveState {
    breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

@Injectable({
    providedIn: 'root'
})
export class ResponsiveStore extends ComponentStore<ResponsiveState> {
    constructor() {
        super({
            breakpoint: 'xs'
        });
    }

    readonly breakpoint$ = fromEvent(window, 'resize').pipe(
        startWith(null),
        tap(() => {
            const width = window.innerWidth;
            if (width >= 1536) {
                this.updateBreakpoint('2xl');
            } else if (width >= 1280) {
                this.updateBreakpoint('xl');
            } else if (width >= 1024) {
                this.updateBreakpoint('lg');
            } else if (width >= 768) {
                this.updateBreakpoint('md');
            } else if (width >= 640) {
                this.updateBreakpoint('sm');
            } else {
                this.updateBreakpoint('xs');
            }
        }),
        switchMap(() => this.select(state => state.breakpoint))
    );

    readonly updateBreakpoint = this.updater(
        (state, breakpoint: ResponsiveState['breakpoint']): ResponsiveState => ({
            ...state,
            breakpoint
        })
    );
}
